// src/data/noiseKnowledgeBase.ts
// Knowledge base lokal untuk RAG - berisi informasi tentang kebisingan dan dampaknya

export interface KnowledgeEntry {
  id: string;
  category: string;
  question_patterns: string[];
  content: string;
  keywords: string[];
}

export const noiseKnowledgeBase: KnowledgeEntry[] = [
  {
    id: "kb-001",
    category: "definisi",
    question_patterns: [
      "apa itu kebisingan",
      "definisi noise",
      "pengertian polusi suara",
    ],
    content:
      "Kebisingan (noise pollution) adalah suara yang tidak diinginkan yang mengganggu lingkungan. " +
      "Menurut WHO, kebisingan lingkungan di atas 55 dB di siang hari dan 45 dB di malam hari " +
      "dapat mengganggu kesehatan. Satuan ukuran kebisingan adalah desibel (dB). " +
      "Level 0 dB adalah ambang pendengaran manusia, sementara 130 dB adalah ambang rasa sakit.",
    keywords: ["kebisingan", "noise", "polusi suara", "definisi", "pengertian", "apa itu"],
  },
  {
    id: "kb-002",
    category: "klasifikasi",
    question_patterns: [
      "kategori kebisingan",
      "tingkat kebisingan",
      "klasifikasi noise",
      "tenang berisik",
    ],
    content:
      "Klasifikasi tingkat kebisingan: " +
      "1) TENANG (≤40 dB): Seperti perpustakaan, kamar tidur malam hari. Aman untuk kesehatan. " +
      "2) SEDANG (41-60 dB): Seperti percakapan normal, kantor. Masih dalam batas wajar. " +
      "3) BERISIK (61-80 dB): Seperti lalu lintas padat, mesin cuci. Dapat mengganggu konsentrasi dan tidur. " +
      "4) SANGAT BERISIK (>80 dB): Seperti klakson, mesin bor, konser. Berbahaya bagi kesehatan jika paparan berkepanjangan.",
    keywords: ["kategori", "klasifikasi", "tingkat", "level", "tenang", "berisik", "sangat berisik", "sedang"],
  },
  {
    id: "kb-003",
    category: "dampak_kesehatan",
    question_patterns: [
      "dampak kebisingan terhadap kesehatan",
      "bahaya noise",
      "efek kebisingan",
      "kesehatan pendengaran",
    ],
    content:
      "Dampak kebisingan terhadap kesehatan meliputi: " +
      "1) Gangguan pendengaran: Paparan >85 dB dalam waktu lama dapat menyebabkan tuli permanen. " +
      "2) Stres dan kecemasan: Kebisingan kronis meningkatkan hormon kortisol. " +
      "3) Gangguan tidur: Suara >45 dB di malam hari mengganggu kualitas tidur. " +
      "4) Penyakit kardiovaskular: Paparan jangka panjang meningkatkan risiko hipertensi dan penyakit jantung. " +
      "5) Gangguan kognitif: Anak-anak di lingkungan bising cenderung mengalami keterlambatan perkembangan kognitif. " +
      "6) Tinnitus: Denging di telinga akibat kerusakan sel-sel rambut di koklea.",
    keywords: ["dampak", "kesehatan", "bahaya", "efek", "pendengaran", "stres", "tidur", "jantung", "tuli"],
  },
  {
    id: "kb-004",
    category: "sumber_kebisingan",
    question_patterns: [
      "sumber kebisingan",
      "penyebab noise",
      "dari mana kebisingan",
      "sumber polusi suara",
    ],
    content:
      "Sumber-sumber utama kebisingan lingkungan: " +
      "1) Transportasi: Lalu lintas kendaraan (70-85 dB), klakson (100-110 dB), kereta api (80-100 dB), pesawat (120-140 dB). " +
      "2) Konstruksi: Mesin bor (100 dB), palu pneumatik (110 dB), excavator (85-95 dB). " +
      "3) Industri: Pabrik dan mesin produksi (80-110 dB). " +
      "4) Hiburan: Konser musik (110-120 dB), nightclub (100-115 dB). " +
      "5) Alam: Guntur (120 dB), angin kencang (60-70 dB). " +
      "6) Domestik: Generator (80-95 dB), mesin potong rumput (85-90 dB).",
    keywords: ["sumber", "penyebab", "transportasi", "konstruksi", "industri", "hiburan", "alam", "kendaraan"],
  },
  {
    id: "kb-005",
    category: "regulasi",
    question_patterns: [
      "peraturan kebisingan",
      "standar kebisingan indonesia",
      "batas kebisingan yang diperbolehkan",
      "regulasi noise",
    ],
    content:
      "Regulasi kebisingan di Indonesia: " +
      "Berdasarkan KepMenLH No. 48 Tahun 1996 tentang Baku Tingkat Kebisingan: " +
      "- Perumahan dan pemukiman: Maks. 55 dB. " +
      "- Daerah perdagangan dan jasa: Maks. 70 dB. " +
      "- Perkantoran: Maks. 65 dB. " +
      "- Kawasan industri: Maks. 70 dB. " +
      "- Rumah sakit dan sejenisnya: Maks. 55 dB. " +
      "- Sekolah: Maks. 55 dB. " +
      "- Tempat ibadah: Maks. 55 dB. " +
      "WHO merekomendasikan batas sehat: 55 dB siang hari, 45 dB malam hari.",
    keywords: ["regulasi", "peraturan", "standar", "batas", "indonesia", "who", "aturan", "hukum"],
  },
  {
    id: "kb-006",
    category: "solusi",
    question_patterns: [
      "cara mengurangi kebisingan",
      "solusi noise",
      "tips mengatasi kebisingan",
      "pencegahan polusi suara",
    ],
    content:
      "Solusi mengurangi kebisingan: " +
      "1) Barrier fisik: Tembok peredam, pagar tanaman, window insulation. " +
      "2) Personal protection: Earplug (mengurangi 15-30 dB), earmuff (mengurangi 20-30 dB). " +
      "3) Urban planning: Zonasi kawasan, green belt, pedestrianisasi. " +
      "4) Teknologi: Kendaraan listrik, mesin rendah emisi suara, noise-cancelling. " +
      "5) Kebijakan: Jam operasional konstruksi, speed limit, zona tenang. " +
      "6) Rumah: Kusen ganda, karpet tebal, tirai akustik, material peredam.",
    keywords: ["solusi", "cara", "mengurangi", "tips", "atasi", "pencegahan", "peredam", "earplug"],
  },
  {
    id: "kb-007",
    category: "aplikasi",
    question_patterns: [
      "cara pakai aplikasi",
      "fungsi aplikasi",
      "fitur econoise",
      "panduan aplikasi",
    ],
    content:
      "EcoNoise adalah aplikasi deteksi polusi kebisingan berbasis AI. Fitur utama: " +
      "1) Peta Interaktif: Melihat area kebisingan secara real-time di peta. " +
      "2) Analisis Audio: Upload file audio untuk dianalisis tingkat kebisingannya menggunakan AI. " +
      "3) Klasifikasi Otomatis: AI mengklasifikasikan sumber kebisingan (Traffic, Construction, Event, dll). " +
      "4) Chatbot Pintar: Tanyakan tentang kebisingan, dapatkan statistik area, dan rekomendasi. " +
      "5) Cluster View: Melihat area kebisingan yang digabungkan menjadi cluster berdasarkan kedekatan lokasi. " +
      "6) Status Area: Setiap laporan memiliki status (active, expiring, expired) berdasarkan kategori sumbernya.",
    keywords: ["aplikasi", "fitur", "fungsi", "cara pakai", "econoise", "panduan", "peta", "analisis"],
  },
  {
    id: "kb-008",
    category: "statistik",
    question_patterns: [
      "jumlah wilayah",
      "statistik area",
      "berapa banyak",
      "data kebisingan",
      "summary noise",
    ],
    content:
      "Untuk melihat statistik wilayah kebisingan secara real-time, saya bisa mengambil data terbaru dari database. " +
      "Data mencakup jumlah wilayah berdasarkan kategori: Tenang, Sedang, Berisik, dan Sangat Berisik. " +
      "Setiap kategori dihitung berdasarkan rata-rata tingkat kebisingan (dB) dari cluster yang aktif di peta.",
    keywords: ["jumlah", "statistik", "wilayah", "area", "berapa", "data", "summary", "total", "banyak"],
  },
];

/**
 * Melakukan pencarian sederhana di knowledge base berdasarkan keyword matching.
 * Mengembalikan dokumen yang paling relevan dengan query.
 */
export function searchKnowledgeBase(query: string, topK: number = 3): KnowledgeEntry[] {
  const queryLower = query.toLowerCase();
  const queryWords = queryLower.split(/\s+/).filter((w) => w.length > 2);

  const scored = noiseKnowledgeBase.map((entry) => {
    let score = 0;

    // Cek keyword match
    for (const keyword of entry.keywords) {
      if (queryLower.includes(keyword.toLowerCase())) {
        score += 3;
      }
      for (const word of queryWords) {
        if (keyword.toLowerCase().includes(word) || word.includes(keyword.toLowerCase())) {
          score += 1;
        }
      }
    }

    // Cek question pattern match
    for (const pattern of entry.question_patterns) {
      if (queryLower.includes(pattern.toLowerCase())) {
        score += 5;
      }
      const patternWords = pattern.toLowerCase().split(/\s+/);
      const matchCount = patternWords.filter((pw) =>
        queryWords.some((qw) => pw.includes(qw) || qw.includes(pw))
      ).length;
      score += matchCount;
    }

    return { entry, score };
  });

  return scored
    .filter((s) => s.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, topK)
    .map((s) => s.entry);
}
